import { getInputPosition } from "@/components/tiptap/utils/getInputPosition";

import type { DocumentModel } from "@/models/DocumentModel";
import type { SuggestionContext } from "@/models/SuggestionsModel";
import type { EditorView } from "@tiptap/pm/view";

export function setInputValueFromSelection(
  doc: DocumentModel,
  view: EditorView,
): [number, number, string] {
  const [start, end, text] = getInputPosition(view.state, true);
  const { $from, $to } = view.state.selection;
  const isSingleWord = text !== "" && !/\s/.test(text) && $from.sameParent($to);

  if (!isSingleWord) {
    return [start, end, ""];
  }

  doc.input.setValue(text);
  return [start, end, text];
}

export function openSelectionSuggestions(
  doc: DocumentModel,
  view: EditorView,
  x: number,
  y: number,
): SuggestionContext {
  doc.input.reset();
  const [start, end, value] = setInputValueFromSelection(doc, view);
  const context = doc.selection.isMathOnlySelection ? "math_node" : "text_selection";
  doc.editor.suggestions.openAt(x, y, context);

  if (value) {
    doc.input.setInputPosRange({ from: start, to: end }, true);
  }

  return context;
}
